const videoConfig = {
  label: "Video",
  resourceEndpoint: "videos",
  listMetadata: [
    "sort_order",
    "title",
    "featured",
    "topics",
    "categories",
    "release_date",
    "tags",
    "actions",
  ],
  searchKeys: ["title"],
  keepListMetadataOrder: true,
  detailsMetadata: [
    {
      name: "actionclip",
      label: "ActionClip",
      conditions: [
        {
          relativeField: "title",
          comparisonFunc: (_relativeField, _thisField, setup) => {
            return setup?.actionclips;
          },
        },
      ],
    },
    {
      name: "actionclip_description",
      label: "ActionClip Description",
      conditions: [
        {
          relativeField: "actionclip",
          comparisonFunc: (relativeField, thisField, setup) => {
            return relativeField.value === true && setup?.actionclips;
          },
        },
      ],
      validations: [{ type: "max", params: [75, "Maximum 75 Characters"] }],
    },
    {
      name: "title",
      label: "Video Name",
      validations: [
        { type: "required", params: ["Required"] },
        { type: "max", params: [60, "Maximum 60 Characters"] },
      ],
    },
    { name: "description", label: "Description" },
    { name: "web_description", label: "Description" },
    {
      name: "video_url",
      label: "Video URL",
      validations: [{ type: "required", params: ["Required"] }],
    },
    { name: "image_url", label: "Image URL" },
    {
      name: "release_date",
      label: "Release Date"
    },
    {
      name: "cta_type",
      label: ""
    },
    {
      name: "action_bar_text",
      label: "Call to Action Text",
      conditions: [
        {
          relativeField: ["cta_type", "actionclip"],
          comparisonFunc: (relativeField, _thisField, setup) => {
            return !["Preset CTA", "Launch Business"].includes(relativeField.cta_type.value);
          },
        },
      ],
    },
    {
      name: "action_bar_text_enterprise",
      label: "Launch Business Call to Action Text",
      conditions: [
        {
          relativeField: ["cta_type", "actionclip"],
          comparisonFunc: (relativeField, _thisField, setup) => {
            return relativeField?.cta_type?.value === "Launch Business" && relativeField?.actionclip?.value === false && setup?.enterprise_launch_business;
          },
        },
      ],
    },
    { 
      name: "action_bar_text_actionclip",       
      conditions: [
        {
          relativeField: "actionclip",
          comparisonFunc: (relativeField, thisField, setup) => {
            return relativeField.value === true && setup?.actionclips;
          },
        },
      ], 
    },
    {
      name: "action_bar_url",
      label: "Call to Action URL",
      conditions: [
        {
          relativeField: ["cta_type", "actionclip"],
          comparisonFunc: (relativeField, _thisField) => {
            return !["Preset CTA", "Launch Business"].includes(relativeField.cta_type.value);
          },
        },
      ],
    },
    {
      name: "enterprise_app",
      label: "Which Business?",
      conditions: [
        {
          relativeField: ["cta_type", "actionclip"],
          comparisonFunc: (relativeField, _thisField, setup) => {
            return relativeField?.cta_type?.value === "Launch Business" && relativeField?.actionclip?.value === false && setup?.enterprise_launch_business;
          },
        },
      ],
    },{
      name: "cta",
      label: "Call to Action Name List",
      conditions: [
        {
          relativeField: "cta_type",
          comparisonFunc: (relativeField, _thisField) => {
            return relativeField.value === "Preset CTA";
          },
        },
      ],
    },
    { name: "sort_order", label: "Sort Order" },
    { name: "featured", label: "Featured ?" },
    { name: "topics", label: "Topics/Listings" },
    { name: "categories", label: "Categories" },
    { name: "sort_order", label: "Sort Order" },
    { name: "tags", label: "Tags" }
  ],
  formLayout: {
    columns: [
      [
        "actionclip",
        "actionclip_description",
        "title",
        "video_url",
        "cta_type",
        "action_bar_text",
        "action_bar_text_enterprise",
        "action_bar_text_actionclip",
        "action_bar_url",
        "enterprise_app",
        "cta",
        "sort_order",
      ],
      [
        "description",
        "image_url",
        "featured",
        "topics",
        "categories",    
        "tags",
        "release_date",
      ],
    ],
  },
};

export default videoConfig;
